import { render, staticRenderFns } from "./TradeRequestDirectForm.vue?vue&type=template&id=488f0b15"
import script from "./TradeRequestDirectForm.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TradeRequestDirectForm.vue?vue&type=style&index=1&id=488f0b15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports